module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-29.5ccdab4d.png";